export default __webpack_public_path__ + "static/media/art-pro-brw-2.0e84516b.png";